// extracted by mini-css-extract-plugin
export var totalPrice = "index-module--totalPrice--2QdkO";